import './UploadBook.css'
import { Amplify, Storage } from "aws-amplify";
import awsconfig from "../aws-exports";
import { useState } from 'react';
import DragDropFiles from './DragDropFiles';
import Tooltip from '@mui/material/Tooltip';
import { MdOutlineUploadFile } from 'react-icons/md';
Amplify.configure(awsconfig);

function UploadBook(props) {

  const { /*bucketname,*/currentPath, onNewFileUpload } = props

  const [reloadAllUploadedFilesPage, setReloadAllUploadedFilesPage] = useState({})
  const [openDragDropPopUp, setOpenDragDropPopUp] = useState(false)
  const [response, setResponse] = useState({})

  async function upload(e) {
    // e.preventDefault()
    // const file = e.target.files[0];
    const file = e;
    try {
      const response = await Storage.put(currentPath + file.name, file, {
        // bucket: bucketname,
        level: 'private',
        // resumable: true,
        contentType: ['application/docx', 'application/pdf', 'application/txt', 'application/xls', 'application/xlsx', 'application/png', 'application/jpeg',],
        progressCallback(progress) {
          console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
        },
      });
      setReloadAllUploadedFilesPage(response)
      onNewFileUpload(reloadAllUploadedFilesPage)
      setResponse(response)
      console.log(response);
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }

  function onUploadButtonClickHandler() {
    openDragDropPopUp === false ? setOpenDragDropPopUp(true) : setOpenDragDropPopUp(false)
  }

  return (
    <div>
      <div className='uploadbook'>
        <Tooltip title="Upload file" placement='top-start'>
          <button
            id='upload-button'
            onClick={() => { onUploadButtonClickHandler() }}
          ><MdOutlineUploadFile id='upload-file-icon' /></button>
        </Tooltip>
      </div>
      <DragDropFiles upload={upload} openDragDropPopUp={openDragDropPopUp} setOpenDragDropPopUp={setOpenDragDropPopUp} response={response} currentPath={currentPath.toString} />
    </div>
  );
}

export default UploadBook;
